<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="row">
             <bita-select
                     id="provincestate"
                      name="province"
                      label="استان"
                      ref="provinceDropDown"
                      rules="required"
                        validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="provinces"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="province_id"
                    @change="(e) => requestSearch(e)"
                    />

            <bita-input
              type="text"
              name="city_name"
              validation-container-class="col-lg-2"
              input-class="form-control"
              subtitle="نام شهر خود را جستجو نمایید"
              v-model="search"
            />
            <div class="col-12 col-md-2 mt-3 pt-1">
              <div class="d-flex">
                <bita-bootbutton
                  class="w-100"
                  type="primary"
                  title="جستجو"
                  icon="fa fa-search"
                  @click.native="findLoads"
                />
                <bita-bootbutton
                  class="w-100 mr-2"
                  type="info"
                  title="ایجاد شهر"
                  icon="fa fa-plus-square"
                  @click.native="toggleCreateModal"
                />
              </div>
            </div>
          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <create-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="ایجاد شهر"
      :states="states"     
      @on-submit="handleCreate"
    />
    <update-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="editForm"
      modal-id="edit-modal"
      title="ویرایش شهر"
      @on-submit="handleEdit"
    />
  </div>
</template>
<script>
import Create from "./Create";
import Update from "./Update";
export default {
  components: { "create-modal": Create, "update-modal": Update },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت شهر ها",
          link: "/manage/city",
          active: true,
        },
      ],
      isLoadingForm: false,
      parentData: {},
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      provinces:[],
      states: [],
      province_id:null,

      search: "",
      category: {
        name: "",
      },
      editForm: { asfas: "asfasf" },
      gridColumns: [
        { title: "#", template: this.getTemplateID, width: "40px" },
        { field: "name", title: "نام شهر", width: "100px" },
        {
          field: "parent",
          title: "نام استان",
          template: (e) => (e.parent ? e._parent.name : " - "),
          width: "100px",
        },
        { field: "deliver_radius", title: "شعاع", width: "100px" },
        {
          field: "latitude",
          title: "Lat",
          template: (e) => (e.latitude ? e.latitude : " - "),
          width: "100px",
        },
        {
          field: "longitude",
          title: "Long",
          template: (e) => (e.longitude ? e.longitude : " - "),
          width: "100px",
        },
        {
          title: "عملیات",
          command: [],
          width: "100px",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
    this.getProvinces()

  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      return commands;
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      let baseUrl = `/cities?filter[search]=${this.search}&include=parent`;
      if(this.province_id!==null) {
        baseUrl += `&filter[province]=${this.province_id}`;
      } else {
        baseUrl += `&filter[unProvince]=0`;
      }

      this.$persistClient("get", baseUrl)
        .then((res) => {
          this.parentData = JSON.parse(
            JSON.stringify(res.data)
              .split('"parent":')
              .join('"_parent":')
          );
          e.success(this.parentData);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    toggleCreateModal() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    edit(e) {
      this.editForm = this.$refs.grid.getSelectedGridRow(e);
      this.statusChangeModalEdit();
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "cities", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);

          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;

          this.toggleCreateModal();
        });
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        deliver_radius: e.deliver_radius,
        latitude: e.latitude,
        longitude: e.longitude,
        ebl_id: e.ebl_id,
      };
      this.$persistClient("patch", `cities/${e.id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    findLoads(e) {
      this.loadData();
    },
    getProvinces() {

      this.$persistClient("get", "cities?filter[province]=0")
        .then((res) => {
          this.provinces = res.data;
          this.states = res.data; 
        })
        .finally(() => { });
    },
    requestSearch: _.debounce(function () {
      this.loadData();
    }, 1000),


  },
};
</script>
